import { useEffect, useRef } from 'react'

import Icon from 'components/UI/Icon'

const ErrorMessageWithExclamation = ({ text, scroll = false, className = '' }) => {
  const ref = useRef(null)

  useEffect(() => {
    if (scroll && ref.current) {
      ref.current?.scrollIntoView({
        inline: 'center',
        block: 'center',
      })
    }
  }, [scroll])

  return (
    <p
      ref={ref}
      className={`inline-flex items-center font-semibold text-sm text-error-500 mt-1 ${className}`}
    >
      <Icon className="!mr-2" name="exclamation-mark-circle" />
      <span className="flex-1">{text}</span>
    </p>
  )
}

export default ErrorMessageWithExclamation
